// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/.pnpm/css-loader@7.1.4_webpack@5.105.4/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/.pnpm/css-loader@7.1.4_webpack@5.105.4/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * Shared Responsive Variables
 * Used across all Haven MFEs to ensure consistent breakpoints and responsive behavior
 */

:root {
  /* Breakpoints */
  --breakpoint-sm: 640px;
  --breakpoint-md: 768px;
  --breakpoint-lg: 1024px;
  --breakpoint-xl: 1280px;
  --breakpoint-2xl: 1536px;

  /* Mobile-specific spacing */
  --mobile-padding: 16px;
  --mobile-header-height: 56px;
  --mobile-bottom-nav-height: 64px;
  
  /* Touch targets (minimum 44px for accessibility) */
  --touch-target-min: 44px;
  
  /* Z-index layers */
  --z-mobile-nav: 1000;
  --z-mobile-overlay: 999;
  --z-dropdown: 100;
  --z-modal: 200;
}

/* Media Query Mixins (for reference in comments) */
/* 
  Mobile: max-width: 767px
  Tablet: min-width: 768px and max-width: 1023px
  Desktop: min-width: 1024px
*/
`, "",{"version":3,"sources":["webpack://./../../shared/responsive-variables.css"],"names":[],"mappings":"AAAA;;;EAGE;;AAEF;EACE,gBAAgB;EAChB,sBAAsB;EACtB,sBAAsB;EACtB,uBAAuB;EACvB,uBAAuB;EACvB,wBAAwB;;EAExB,4BAA4B;EAC5B,sBAAsB;EACtB,4BAA4B;EAC5B,gCAAgC;;EAEhC,mDAAmD;EACnD,wBAAwB;;EAExB,mBAAmB;EACnB,oBAAoB;EACpB,uBAAuB;EACvB,iBAAiB;EACjB,cAAc;AAChB;;AAEA,mDAAmD;AACnD;;;;CAIC","sourcesContent":["/**\n * Shared Responsive Variables\n * Used across all Haven MFEs to ensure consistent breakpoints and responsive behavior\n */\n\n:root {\n  /* Breakpoints */\n  --breakpoint-sm: 640px;\n  --breakpoint-md: 768px;\n  --breakpoint-lg: 1024px;\n  --breakpoint-xl: 1280px;\n  --breakpoint-2xl: 1536px;\n\n  /* Mobile-specific spacing */\n  --mobile-padding: 16px;\n  --mobile-header-height: 56px;\n  --mobile-bottom-nav-height: 64px;\n  \n  /* Touch targets (minimum 44px for accessibility) */\n  --touch-target-min: 44px;\n  \n  /* Z-index layers */\n  --z-mobile-nav: 1000;\n  --z-mobile-overlay: 999;\n  --z-dropdown: 100;\n  --z-modal: 200;\n}\n\n/* Media Query Mixins (for reference in comments) */\n/* \n  Mobile: max-width: 767px\n  Tablet: min-width: 768px and max-width: 1023px\n  Desktop: min-width: 1024px\n*/\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
